import { render, staticRenderFns } from "./Portfolio_balance.vue?vue&type=template&id=faa641c2&scoped=true&"
import script from "./Portfolio_balance.vue?vue&type=script&lang=js&"
export * from "./Portfolio_balance.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio_balance.vue?vue&type=style&index=0&id=faa641c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa641c2",
  null
  
)

export default component.exports